import React from "react";

const PageLoader= () => {
  return <h1 className="loader">Jacob <br></br>Grønberg</h1>;
};

export default PageLoader;
